<template lang="pug">
.reserve-page
  .main-title
    .person
      .person-fullName
        .firstName Hello {{ $root.member.user_name }}
        .lastName {{ $root.member.name }}
      .person-avatar
        img.user-pic(:src="$root.member.user_picture", alt="alt")
    p 歡迎預約
  
  .store-plans
    .sub-title 
      | 請選擇租借時間
    .button-choose
      button.stepHour(type="button" @click="selectType('hour')" :class="{active: now_select === 'hour'}") 
        .step-txt 小時
      button.stepDay(type="button" @click="selectType('day')" :class="{active: now_select === 'day'}") 
        .step-txt 天
      button.frequency(type="button" @click="selectType('frequency')" :class="{active: now_select === 'frequency'}") 
        .step-txt 次

  .store-plans(v-if="['9990001','9990002','1001001','1001002'].indexOf($root.register.stationId) > -1")
    .sub-title.sub-title-2
      | 或選擇優惠方案
    .button-choose
      button.stepHour(type="button" @click="selectType('planA')" :class="{active: now_select === 'planA'}") 
        .step-txt A方案
      button.stepDay(type="button" @click="selectType('planB')" :class="{active: now_select === 'planB'}") 
        .step-txt B方案
      button.frequency(type="button" @click="selectType('planC')" :class="{active: now_select === 'planC'}") 
        .step-txt C方案
    p.plan-aler-text(v-if="now_select === 'planA'") A方案: 300/2HR 固定價格
    p.plan-aler-text(v-if="now_select === 'planB'") B方案: 500/4HR 固定價格
    p.plan-aler-text(v-if="now_select === 'planC'") C方案: 800/天 固定價格

  van-calendar.calendar-dates(
    title=""
    :min-date="new Date(new Date().setDate(new Date().getDate() + 1))"
    :max-date="new Date(new Date().getTime()+24*60*60*1000*30)"
    :poppable="false"
    :show-confirm="false"
    :style="{ height: '361px' }"
    color="#22F48F"
    :show-title="false"
    :type="now_select === 'day' ? 'range' : 'single'"
    @select="choiceDate"
  )
  .available-dates
    .heading {{ reserve_date }} 預計預約時間
    ul 
      li(
        v-for="dtime of time_options" 
        :key="dtime.id" 
        v-if="canUseTime(dtime)"
        @click="reserveItem(dtime.content)" 
        :class="{active: reserve_time === dtime.content}"
      ) {{dtime.content}}

  //- 歸還時間 選擇「次」不顯示
  .available-dates(v-if="now_select !== 'frequency'")
    .heading {{ return_date }} 預計歸還時間
    ul 
      li(
        v-for="rtime of time_options" 
        :key="rtime.id" 
        v-if="canUseTime(rtime)"
        @click="returnItem(rtime.content)" 
        :class="{active: return_time === rtime.content}"
      ) {{rtime.content}}

  .button-group
    button.stepUp(type="button" @click="$router.go(-1)") 
      .step-txt 上一步
    button.stepNext(type="button" @click="goNext" :class="{active: can_submit}") 
      .step-txt 下一步
</template>

<script>
import Vue from "vue";
import { Calendar } from "vant";

Vue.use(Calendar);
export default {
  name: "reserve-page",
  components: {},
  data () {
    return {
      can_submit: false,
      now_select: 'hour',
      reserve_date: '',
      return_date: '',
      reserve_time: '',
      return_time: '',
      time_options: [
        { id: "011", content: "07:00" },
        { id: "012", content: "08:00" },
        { id: "013", content: "09:00" },
        { id: "001", content: "10:00" },
        { id: "002", content: "11:00" },
        { id: "003", content: "12:00" },
        { id: "004", content: "13:00" },
        { id: "005", content: "14:00" },
        { id: "006", content: "15:00" },
        { id: "007", content: "16:00" },
        { id: "008", content: "17:00" },
        { id: "008", content: "18:00" },
        { id: "008", content: "19:00" },
        { id: "008", content: "20:00" },
        { id: "008", content: "21:00" },
      ],
    };
  },
  watch: {
    now_select (_val) {
      // 取明天日期
      var tomorrow = new Date();
      tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
      let tomorrowDay = this.$root.common.getNowTime('date', tomorrow)

      if (_val === 'day') {
        this.reserve_date = tomorrowDay
        this.return_date = tomorrowDay
      } else {
        this.reserve_date = tomorrowDay
        this.return_date = tomorrowDay
      }

      if (_val === 'frequency') {
        this.return_time = ''
      }
    },
    reserve_date () {
      this.checkNext()
    },
    return_date () {
      this.checkNext()
    },
    reserve_time () {
      this.checkNext()
    },
    return_time () {
      this.checkNext()
    },
  },
  created () {
    console.log('--> 目前預約資訊:', this.$root.register)

    // 取明天日期
    var tomorrow = new Date();
    tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
    let tomorrowDay = this.$root.common.getNowTime('date', tomorrow)

    // 處理預設日期
    this.reserve_date = tomorrowDay
    this.return_date = tomorrowDay
  },
  mounted () { },
  methods: {
    // 選擇類型
    selectType (_type) {
      if (['9990001', '9990002'].indexOf(this.$root.register.stationId) > -1) {
        if (['hour', 'planA', 'planB', 'planC'].indexOf(_type) < 0) {
          return
        }
      }

      this.now_select = _type
    },
    // 選擇日期
    choiceDate (e) {
      if (Array.isArray(e)) {
        this.reserve_date = this.$root.common.getNowTime('date', e[0])
        this.return_date = this.$root.common.getNowTime('date', e[1])
      } else {
        this.reserve_date = this.$root.common.getNowTime('date', e)
        this.return_date = this.$root.common.getNowTime('date', e)
      }
    },
    // 選擇預約時間
    reserveItem (_id) {
      this.reserve_time = _id
    },
    // 選擇歸還時間
    returnItem (_id) {
      this.return_time = _id
    },
    canUseTime (_time) {
      let stationId = this.$root.register.stationId
      let station = this.$root.stations.find(item => item.id === stationId)
      let timeText = _time.content

      // 如果沒有開放時間
      if (!station.start_time || !station.end_time) {
        return true
      }

      // 開放時間, 取前五個字
      let startTime = station.start_time.substring(0, 5)
      let endTime = station.end_time.substring(0, 5)

      // 判斷是否在開放時間內
      if (timeText >= startTime && timeText <= endTime) {
        console.log('=> ' + timeText + ' 在開放時間(' + startTime + '~' + endTime + ')內')
        return true
      }

      return false
    },
    checkNext () {
      if (this.now_select && this.reserve_date && this.return_date && this.reserve_time) {
        // 判斷是否為「次」
        if (this.now_select === 'frequency') {
          this.can_submit = true
        } else if (this.return_time) {
          this.can_submit = true
        }
      } else {
        this.can_submit = false
      }
    },
    goNext () {
      if (this.can_submit) {
        this.$root.register.timeType = this.now_select

        // 需要計算小時差
        if (['hour', 'planA', 'planB', 'planC'].indexOf(this.now_select) > -1) {
          this.$root.register.startTime = this.reserve_date + " " + this.reserve_time
          this.$root.register.endTime = this.return_date + " " + this.return_time
          let hours = this.$root.common.calculateHourDifference(
            this.$root.common.getNowTime('timestamp', this.$root.register.startTime + ':00'),
            this.$root.common.getNowTime('timestamp', this.$root.register.endTime + ':00')
          )

          // 如果時數低於 0
          if (parseInt(hours) <= 0) {
            alert("請重新檢查您選取的時間區間喔！")
            return false
          }

          this.$root.register.hours = hours
          console.log('=> 相差時數:', this.$root.register.hours)
        }

        // 需要計算天數差
        if (this.now_select === 'day') {
          this.$root.register.startTime = this.reserve_date + " " + this.reserve_time
          this.$root.register.endTime = this.return_date + " " + this.return_time
          let startTime = this.reserve_date
          let endTime = this.return_date
          let days = this.$root.common.calculateDayDifference(
            this.$root.common.getNowTime('timestamp', startTime + " 00:00:00"),
            this.$root.common.getNowTime('timestamp', endTime + " 23:59:59")
          )

          this.$root.register.days = days

          // 如果時數低於 0
          if (parseInt(days) <= 0) {
            alert("請重新檢查您選取的時間區間喔！")
            return false
          }

          console.log('=> 相差天數:', this.$root.register.days)
        }

        this.$root.goPage('/trial-calculation')
      }
    }
  },
};
</script>
<style lang="sass" scoped>
.reserve-page
  // margin-top: 74px
  padding: 48px 35px 150px
  height: 100%
  overflow: auto
  .main-title
    .person
      display: flex
      justify-content: space-between
      align-items: center
      .person-fullName
        font-size: 32px
        font-weight: 700
        line-height: 2ex
        color: #fff
      .person-avatar
        width: 50px
        img
          width: 100%
          vertical-align: middle
    p
      font-size: 24px
      font-weight: 400
      color: #fff
      // padding-top: 13px
  .sub-title
    font-size: 18px
    font-weight: 700
    color: #898A8D
    padding-top: 34px
  .button-choose
    display: flex
    align-items: center
    gap: 12px
    padding: 7px
    border-radius: 10px
    background-color: #1E1E1E
    .stepHour,.stepDay,.frequency
      width: 160px
      border-radius: 5px
      border: none
      &.active
        background: #22F48F
        .step-txt
          color: #000
      .step-txt
        font-size: 18px
        font-weight: 700
        color: #898a8d
  .available-dates
    margin-top: 30px
    .heading
      font-size: 18px
      font-weight: 700
      color: #898A8D
    ul
      display: grid
      grid-template-rows: repeat(2,1fr)
      grid-template-columns: repeat(4,1fr)
      gap: 10px 14px
      margin-top: 21px
      box-sizing: border-box
      li
        font-size: 18px
        font-weight: 400
        color: #000
        padding: 9px 10px
        background-color: #fff
        border-radius: 5px
        color: #000
        box-sizing: border-box
        text-align: center
        &.active
          background-color: #22F48F

  .button-group
    padding-top: 15%
    display: flex
    .stepUp
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #fff
      border: none
      padding: 3vmin 0px
    .stepNext
      width: 40vmin
      margin: auto
      border-radius: 12.5vmin
      background-color: #898A8D
      border: none
      padding: 3vmin 0px
      &.active
        background-color: #22F48F
    .step-txt
      text-align: center
      font-size: 6vmin
      font-weight: 700
      color: #1E1E1E
.van-calendar
  background-color: #000
  color: #fff
  font-size: 20px
  ::v-deep .van-calendar__header-subtitle
    text-align: left
    padding-left: 10px
  ::v-deep .van-calendar__days
    gap: 7px 0 
  ::v-deep .van-calendar__day
    font-size: 20px
    height: 11.72vmin
  ::v-deep .van-calendar__weekday
    font-size: 14px
    font-weight: 300
  ::v-deep .van-calendar__month-mark
    display: none
  ::v-deep .van-calendar__bottom-info
    display: none
  ::v-deep .van-calendar__day--disabled
    color: rgba(255,255,255,.3)
  ::v-deep .van-calendar__selected-day
    color: #000
    border-radius: 50%
    height: 11.72vmin
.sub-title
  // margin-bottom: 5px
.reserve-page .sub-title-2
  padding-top: 15px
p.plan-aler-text
  color: #fff
  margin: 15px 0px
</style>
